import React, { useEffect, useState } from 'react';
import { Logout, MenuItemLink, useAuthProvider, useCreatePath } from 'react-admin';
import { IconButton, Menu } from '@mui/material';
import { ReactComponent as ChevronDown } from 'src/assets/chevron-down.svg';
import { Theme } from 'src/Theme';
import './index.css';
import { UserType } from '../../auth/types';
import { UserRoleLabel } from '../../constants';
import UnknownAvatar from '../common/UnknownAvatar';
import { Resource as ResourceName } from '../../constants/resources';
import WithRole from '../common/WithRole';
import { AllExceptAdminGroup } from 'src/constants/roles';

const UserMenu: React.FC = () => {
    const [profile, setProfile] = useState<UserType>();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isOpen = Boolean(anchorEl);
    const { getIdentity } = useAuthProvider();
    const createPath = useCreatePath();

    useEffect(() => {
        getIdentity?.().then((profile) => {
            setProfile(profile as UserType);
        });
    }, [getIdentity]);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(isOpen ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="user_menu__wrapper">
            <IconButton
                onClick={handleOpen}
                sx={{
                    padding: 0,
                    borderRadius: '8px',
                    '&:hover': {
                        background: 'rgba(234, 233, 233, 0.671)'
                    }
                }}>
                <div className="user_menu_container">
                    <UnknownAvatar lastName={profile?.surname || ''} firstName={profile?.name} size="medium" />
                    <div className="user_menu_titles">
                        <div className="user_menu__name">{profile?.surname + ' ' + profile?.name}</div>
                        <div className="user_menu__role">
                            {profile?.authorities?.map((role) => UserRoleLabel[role] || '').join(', ')}
                        </div>
                    </div>
                    <ChevronDown
                        style={{
                            transform: isOpen ? 'rotate(180deg)' : 'none',
                            transition: 'transform 0.2s',
                            minWidth: '20px'
                        }}
                    />
                </div>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={isOpen}
                onClose={handleClose}
                onClick={handleClose}
                autoFocus={false}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                sx={{
                    '& .MuiPaper-root': {
                        marginTop: '8px',
                        minWidth: '180px',
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                        borderRadius: '8px'
                    }
                }}>
                <WithRole roles={AllExceptAdminGroup}>
                    <MenuItemLink
                        to={createPath({ resource: ResourceName.PROFILE, type: 'show', id: profile?.id })}
                        primaryText="Мій профіль"
                        sx={{ color: Theme.palette.primary.midnightBlue }}
                        onClick={handleClose}
                    />
                </WithRole>
                <Logout
                    sx={{
                        color: Theme.palette.primary.midnightBlue,
                        width: '100%',
                        justifyContent: 'flex-start',
                        padding: '6px 16px'
                    }}
                />
            </Menu>
        </div>
    );
};

export default UserMenu;
